import { lazy } from 'react';

import { formDrawerRegistry } from '@/app/surfaces/form-drawer-registry.js';

export const CUSTOMERS_LIST_DRAWER_KEY = 'customers-list';
export const REGISTER_PARTY_DRAWER_KEY = 'register-party';

formDrawerRegistry[CUSTOMERS_LIST_DRAWER_KEY] = {
  title: 'Buscar cliente',
  size: 'md',
  component: lazy(async () => {
    const module = await import('@/features/customer/surfaces/customers-list.drawer.js');
    return { default: module.CustomersListDrawer };
  }),
};

formDrawerRegistry[REGISTER_PARTY_DRAWER_KEY] = {
  title: 'Novo cliente',
  size: 'lg',
  component: lazy(async () => {
    const module = await import('@/features/customer/surfaces/register-party.drawer.js');
    return { default: module.RegisterPartyDrawer };
  }),
};
